/* eslint-disable jira/filename-case */
import { token } from '@atlaskit/tokens';

export const TEMPLATE_TILE_WIDTH_IN_PX = 300;

// Two lines of comment-appearance body text (~24px per line; see RenderedDescription compact).
export const TEMPLATE_TILE_SHORT_DESCRIPTION_MAX_HEIGHT_PX = 48;
/**
 * to show max 3 tiles in a row:
 * 3 * ${TEMPLATE_TILE_WIDTH_IN_PX}px - tiles width
 * 2 * ${token('space.200')} - gap between tiles
 * 2 * ${token('space.300')} - modal padding on both sides
 * ${token('space.250')} - scrollbar width
 */
export const MODAL_WIDTH: string = `calc(3 * ${TEMPLATE_TILE_WIDTH_IN_PX}px + 2 * ${token('space.200')} + 2 * ${token('space.300')} + ${token('space.250')})`;
